import React from "react";

function About () {
    return (
        <div className="about">
            <div className="about-image-wrapper">
                <img src="./images/about-image.jpg" className="about-image"/>
            </div>
            <div className="about-note">
                <h2>ABOUT</h2>
                <h3>PROVIDES SIGN LANGGUAGE INTERPRTING AND INSTRUCTION</h3>
                <ul>
                    <li>VODAFONE SIGN  LANGUAGE FACILITATOR <br/><button><a target="_blank" href="https://www.youtube.com/watch?v=_lRyFX1efoo">VIEW MORE</a></button></li><br/>
                    <li>American Sign Language (ASL) Instructor at One Heart Africa Academy (OHAA)<br/><button><a target="_blank" href="https://www.devioearlychildhoodinstitute.org/about">VIEW MORE</a></button></li><br/>
                    <li>Resource person at the Adenta Municipality Asembly (Adma)-Deaf association<br/><button><a target="_blank" href="https://www.youtube.com/@kowcornelius7056/videos">VIEW MORE</a></button></li><br/>
                    <li>Sign Language Instructorat Devio Educational Institute for early childhood development, Canada<br/><button><a target="_blank" href="https://www.devioearlychildhoodinstitute.org/about ">VIEW MORE</a></button></li><br/>
                </ul>
            </div>
        </div>
    );
}


export default About

